/*
 * Unit converters
 * Calculations for converting units.
 */

export function m2ft(m = 0) { return m / 0.3048; }

export function ft2m(ft = 0) { return ft * 0.3048; }

export function mile2km(mile = 0) { return mile * 1.609344; }

export function km2mile(km = 0) { return km / 1.609344; }

export function m2km(m = 0) { return m / 1000; }

export function km2m(km = 0) { return km * 1000; }

export function m2mile(m = 0) { return m / 1609.344; }

export function m2nmile(m = 0) { return m / 1852.00; }

export function mile2m(mile = 0) { return mile * 1609.344; }

export function m2kft(m = 0) { return m * 0.00328083989501; }

export function cm2Feet(cm = 0) { return cm * 0.032808399; }

export function feet2Cm(feet = 0) { return feet * 30.48; }

export function cm2M(cm = 0) { return cm * 0.01; }

export function feet2M(feet = 0) { return cm2M(feet2Cm(feet)); }

export function cm2FeetAndInches(cm = 0) { const totalInches = Math.round((cm / 100) * 39.3700787); return [Math.floor(totalInches / 12), Math.round(totalInches % 12)]; }

export function feetAndInches2cm(feetAndInches = [0, 0]) { return (feetAndInches[0] * 30.48) + (feetAndInches[1] * 2.54); }

export function m2yd(m = 0) { return m * 1.0936; }

export function mps2kmph(mps = 0) { return mps * 3.6; }

export function kmph2mps(kmph = 0) { return kmph / 3.6; }

export function mps2mileph(mps = 0) { return (mps * 3600) / 1609.344; }

export function mileph2mps(mileph = 0) { return (mileph * 1609.344) / 3600; }

export function mps2minpkm(mps = 0) { return 1 / (0.06 * mps); }

export function minpkm2mps(minpkm = 0) { return 1 / (0.06 * minpkm); }

export function minpkm2minpmile(minpkm = 0) { return minpkm * 1.60934; }

export function mps2minpmile(mps = 0) { return 1609.344 / (60 * mps); }

export function minpmile2mps(minpmile = 0) { return 1609.344 / (60 * minpmile); }

export function mps2knot(mps = 0) { return (mps * 3600) / 1852; }

export function knot2mps(knot = 0) { return (knot * 1852) / 3600; }

export function minutesPerKm2MinutesPerMile(minutesPerKm = 0) { return mps2minpmile(minpkm2mps(minutesPerKm)); }

export function minutesPerKm2MinutesPer100m(minutesPerKm = 0) { return minutesPerKm / 10; }

export function minutesPerKm2MinutesPer500m(minutesPerKm = 0) { return minutesPerKm / 2; }

export function minutesPerKm2MinutesPer100yd(minutesPerKm = 0) { return minutesPerKm2MinutesPer100m(minutesPerKm) * (1 / 1.0936); }

export function mps2mpmin(mps = 0) { return mps * 60; }

export function mps2feetpmin(mps = 0) { return mps * 196.850394; }

export function mpmin2feetpmin(mpmin = 0) { return mpmin * 3.28; }

export function kmh2mph(kmh = 0) { return kmh * 0.621371; }

export function secondsToMinutes(seconds = 0) { return seconds / 60; }

export function secondsToHours(seconds = 0) { return seconds / 60 / 60; }

export function hoursToSeconds(hours = 0) { return hours * 60 * 60; }

export function kg2Lbs(kg = 0) { return kg * 2.20462262; }

export function lbs2Kg(lbs = 0) { return lbs * 0.45359237; }

export function hz2rpm(hz = 0) { return hz * 60; }

export function millibar2inHg(millibar = 0) { return millibar * 0.02952998330101009; }

export function uVToMAPerMin(uV = 0) { return Math.round(uV * 0.6); }

export function uVToMA(uV = 0) { return Math.round(uV * 0.01); }

export function hz2bpm(hz = 0) { return hz * 60; }

export function j2kcal(j = 0) { return j / 4186.8; }

export function kcal2j(kcal = 0) { return 4186.8 * kcal; }

export function f2c(f = 0) { return (f - 32) * (5 / 9); }

export function c2f(c = 0) { return (c * (9 / 5)) + 32; }

export function k2c(k = 0) { return k - 273.15; }

export function k2f(k = 0) { return c2f(k2c(k)); }

export function rad2deg(rad = 0) { return rad * 57.2958; }

export function rad2mil(rad = 0) { return rad * 1018.591635788; }
